module.exports = __webpack_public_path__ + "img/icon-cross-grey.72deae91.svg";